import { observable, action, makeObservable, computed } from "mobx";
import { Fields } from "./Fields";
import validateForgotPasswordData from "../../logic/ValidationChecks/ForgotPasswordDataValidation";

export interface IForgotPasswordDataFields {
    email: string;
}

export class ForgotPasswordData extends Fields<IForgotPasswordDataFields, ForgotPasswordData> implements IForgotPasswordDataFields {
    @observable email = "";

    constructor() {
        super();

        makeObservable(this);
    }

    /***** Setters *****/

    @action setEmail(email: string) {
        this.email = email;
    }

    /***** Computed properties *****/

    @computed get validationErrors() {
        return validateForgotPasswordData(this);
    }

    /***** Serialization *****/

    serialize() {
        return this.trimmed;
    }
}